import helpers from '../modules/helpers.js';

/* Create a new dataLayerObject depend on event type */
export default function getDataLayerObject(dataLayerEvent, formData) {
    let object = {};

    // set event type
    Object.assign(object, getDataLayerEventType(dataLayerEvent));

    // loop through fields depend on event type and create a new object
    for(const field in object.fields) {
        if(field in formData) {
            // Merge phone_prefix and phone_number.
            if(field === 'phone_number') {
                Object.assign(object, {[object.fields[field]]: helpers.mergePhonePrefixAndPhoneNumber(formData['phone_prefix'], formData[[field]]) });
            } else {
                Object.assign(object, {[object.fields[field]]: formData[[field]]});
            }
        }
    }

    // delete "fields" key from object
    delete object.fields;

    // return dataLayer object
    return object;
}

/* Get event type */
function getDataLayerEventType(dataLayerEvent) {
    switch(dataLayerEvent) {
        case 'mql':
            return {
                event: dataLayerEvent,
                fields: {
                    firstname: 'user_profile_firstname',
                    lastname: 'user_profile_lastname',
                    email: 'user_profile_email',
                    phone_number: 'user_profile_phone_number',
                }
            }
    }
}